/**
 * Read the message out of a failed request, whatever shape it arrived in.
 *
 * TWO shapes reach an onError in this app, and most call sites only read one:
 *
 *   - `apiClient`'s interceptor normalises failures into an ApiError object —
 *     `{ status, message }`, with NO `.response` on it — before rejecting.
 *   - Anything that bypasses the interceptor (or a future transport) still
 *     looks like a raw axios error, `e.response.data.message`.
 *
 * Reading only the axios shape is how the Workbench showed "Could not save the
 * walk-in client." while the server was saying, precisely, "phone must be in
 * E.164 format, e.g. +919876543210" — the message was on `e.message` all
 * along. 30+ older call sites have the same latent bug.
 *
 * Nest also returns an ARRAY of strings when class-validator rejects more than
 * one field, and `String(array)` runs them together with commas — so the join
 * lives here, once.
 */
export function apiErrorMessage(e: unknown, fallback: string): string {
  const anyErr = e as {
    response?: { data?: { message?: string | string[] } };
    message?: string | string[];
  };
  const m = anyErr?.response?.data?.message ?? anyErr?.message;
  if (Array.isArray(m)) return m.join(" · ");
  return m || fallback;
}
